import { AudioRef, NewLog } from '../../types'

const hasPlayableAudio = ({
  title,
  url,
}: {
  title?: string
  url?: string
}): boolean => Boolean(title?.trim() && url?.trim())

const filterExercisesByCategory = (
  logs: NewLog[],
  category: string,
): { title: string; url: string; routine: string | null }[] => {
  return logs.flatMap((log) => {
    if (category === 'Ejercicios Especiales') {
      if (!log.audio) return []

      const audios: AudioRef[] = Array.isArray(log.audio)
        ? log.audio
        : [log.audio]

      return audios.filter(hasPlayableAudio).map((audio) => ({
        title: audio.title,
        url: audio.url,
        routine: category,
        logUID: log.uid,
        visibility: true,
      }))
    }

    return log.exercises
      .filter((exercise) => exercise.category.includes(category))
      .filter((exercise) => hasPlayableAudio(exercise.exercise))
      .map((exercise) => ({
        title: exercise.exercise.title,
        url: exercise.exercise.url,
        routine: exercise.routine,
        logUID: log.uid,
        visibility: exercise.visibility ?? true,
      }))
  })
}

export const buildRoutinesWithContent = (
  logs: NewLog[],
  categories: string[],
) =>
  categories
    .map((category) => ({
      category,
      content: filterExercisesByCategory(logs, category),
    }))
    .filter((routine) => routine.content.length > 0)
